interface ExportPanelProps {
  orgSlug: string | undefined;
}

const FORMATS: Array<{ key: 'xlsx' | 'csv' | 'json'; label: string; hint: string }> = [
  { key: 'xlsx', label: 'XLSX', hint: 'Full snapshot — parts, suppliers, inventory, BOMs, and lines.' },
  { key: 'csv', label: 'CSV', hint: 'Single-table parts + inventory snapshot.' },
  { key: 'json', label: 'JSON', hint: 'Machine-readable full snapshot.' },
];

export function ExportPanel({ orgSlug }: ExportPanelProps) {
  if (!orgSlug) return null;
  return (
    <section className="rounded-lg border border-stone-200 dark:border-stone-800 bg-white dark:bg-stone-900 p-5">
      <h2 className="font-medium text-stone-900 dark:text-stone-100">Export</h2>
      <p className="mt-1 text-sm text-stone-600 dark:text-stone-400">
        Download a full snapshot of your organization's data. Available so you
        can keep your own backups and so you're never locked in.
      </p>
      <div className="mt-3 flex-wrap gap-2">
        {FORMATS.map((f) => (
          <a
            key={f.key}
            href={`/api/orgs/${orgSlug}/export?format=${f.key}`}
            className="inline-flex items-center gap-2 rounded-md border border-stone-300 dark:border-stone-700 bg-stone-50 dark:bg-stone-900 px-3 py-1.5 text-sm font-medium hover:bg-stone-100 dark:hover:bg-stone-800"
            title={f.hint}
            download
          >
            <span>↓</span>
            <span>{f.label}</span>
          </a>
        ))}
      </div>
    </section>
  );
}
